<template>
    <div class="site-header">
        <a :href="logoLink" class="site-header_logo-link" :title="appLongName + ' Home'">
			<img src="static/img/nih-logo.png" alt="NIH" height="35px"/>
            <h1 class="site-header_site-title long-title">{{appLongName}}</h1>
            <h1 class="site-header_site-title short-title">NIH {{appShortName}}</h1>
        </a>
        <div class="site-header__view-toggle" v-if="currentView == 'home' && appInit">
            <v-button
                :customLabel="'Summary'"
                :customClass="'summary-btn ' + toggleBtnClass('summary')"
                :svg="'fas fa-check'"
                @click="toggleColumnView('summary')"
            />
            <v-button
                :customLabel="'Detail'"
                :customClass="'detail-btn ' + toggleBtnClass('detail')"
                :svg="'fas fa-check'"
                @click="toggleColumnView('detail')"
            />
        </div>

        <!-- HEADER LINKS -->
        <div id="header-links">
			<a :href="faqLink" id="risr-faq-btn" target="_blank" title="RISR FAQ">RISR FAQs</a>&nbsp;|&nbsp;
            <a href="mailto:inclusion@mail.nih.gov?subject=Question about NIH RCDC Inclusion Statistics Report" id="contact-btn" title="Contact us">Contact Us</a>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import globalMixins from '@/js/globalMixins';
export default {
    name: 'SiteHeader',
    mixins: [globalMixins],
    computed: {
        ...mapGetters([
            'appLongName',
            'appShortName',
            'columnView',
            'appInit'
        ]),
        logoLink: function () {
            return location.hostname === 'localhost' ? '/' : location.origin + '/risr';
        },
        faqLink: function () {
            return location.hostname === 'localhost' ? '/' : location.origin + '/reportweb/web/displayreport?rid=957';
        }
    },
    methods: {
        ...mapActions([
            'resetTopFilters',
            'setColumnView',
            'setLoadingNewData'
        ]),
        toggleBtnClass: function (btnType) {
            return this.columnView === btnType ? 'active': '';
        },
        toggleColumnView (view) {
            $('#landing-page-comp').show();

            this.setColumnView(view);
        }
    }
};
</script>

<style lang="scss">
.site-header {
    position: fixed;
    top: 0;
    left: 0;
    height: $header-height;
    background-color: $blue-nih;
    color: #fff;
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    padding: 6px 10px;
    z-index: 100;
    width: 100%;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
}

.site-header_site-title {
    display: inline-block;
    margin: 0 10px 0 0.3em;
    font-size: 22px;
    font-weight: 400;
    vertical-align: middle;
    line-height: 1em;
    color: #fff;
    transition: $tran-speed;
}

.short-title {
    display: none;
}

.site-header_logo {
    display: inline-block;
    width: 50px;
    height: 32px;
    vertical-align: middle;
    color: #fff;
}

.site-header__view-toggle {
    width: 160px;
    position: absolute;
    // right: $home-page-padding;
    right: 180px;
    top: 10px;

    button {
        background-color: #ececec;
        position: relative;

        .svg {
            position: absolute;
            display: none;
            top: 8px;
            left: 3px;
        }

        &.summary-btn {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        &.detail-btn {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }

        &.custom-btn:not(.nohover):not(.svg-only):not(.disabled).active {
            background-color: #203f63;
            color: #fff;
            padding-left: 20px;

            .svg {
                display: block;
                color: #fff;
            }

            &:hover {
                background-color: #203f63;
            }
        }
    }
}



@media only screen and (max-width: 660px) {
    .site-header_site-title.short-title {
        display: inline-block;
        font-size: 22px;
    }

    .long-title {
        display: none;
    }
}

@media only screen and (max-width: 770px) {
    .site-header_site-title {
        font-size: 2.3vw;
    }
}

@media only screen and (max-width: 415px) {
    #app {
        padding: 70px 0 0 0!important;
        overflow: auto!important;
    }

    .site-header {
        height: 70px;

        .site-header__view-toggle {
            right: 26px;
            top: 36px;
        }
    }

    #landing-page-comp {
        .landing-page__content {
            overflow: auto;
        }
        .landing-page__content-wrapper {
            padding: 40px 45px;
        }
    }
}

#header-links {
    position: absolute;
    right: $home-page-padding;
    top: 13px;
    a {
        color: #fff;
        font-weight: bold;
        font-size: 13px;
    }
}
</style>

